<!-- 購入時、決済は完了したが、book_groupのis_paid更新に失敗した場合に表示するダイアログ -->
<template>
  <ItemDialog ref="purchaseError" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        決済の結果をチケットに反映できませんでした。お手数ですがサポートセンターにお問い合わせください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogPurchaseError",
  props: {
    closeClick: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const purchaseError = ref(null);

    const openDialog = () => {
      purchaseError.value.open();
    };

    const closeDialog = async () => {
      // nativeHandlerService.returnNativeAppTopPage();
      await purchaseError.value.close();
      await props.closeClick();
    };

    return {
      props,
      purchaseError,
      openDialog,
      closeDialog,
    };
  },
};
</script>
